import type { StoredJoinSplitNote } from "../joinsplit/types";

function fail(message: string): never {
  throw new Error(`Flat JoinSplit V2 wallet: ${message}`);
}

export function selectForAmount(
  notes: StoredJoinSplitNote[],
  amount: bigint,
): StoredJoinSplitNote[] {
  if (amount <= 0n || amount >= 1n << 120n)
    fail("amount must fit nonzero uint120");
  const sorted = [...notes].sort((a, b) =>
    a.note.value === b.note.value ? 0 : a.note.value > b.note.value ? -1 : 1,
  );
  const selected: StoredJoinSplitNote[] = [];
  let total = 0n;
  for (const note of sorted) {
    if (selected.length === 32 || total >= amount) break;
    selected.push(note);
    total += note.note.value;
  }
  if (total < amount) {
    if (sorted.reduce((sum, note) => sum + note.note.value, 0n) >= amount) {
      fail("balance is too fragmented; consolidate or migrate notes first");
    }
    fail("insufficient spendable private balance in the selected tree");
  }
  // Largest-first above only decides *which* notes to spend. The circuit
  // constrains active input slots to strictly increasing leaf indices — that is
  // what stops the same note being counted twice — so the spend order is fixed
  // here rather than left as whatever the value sort produced.
  return selected.sort((a, b) => a.note.leafIndex - b.note.leafIndex);
}

export function assertAscendingLeafIndices(
  selected: StoredJoinSplitNote[],
): void {
  selected.forEach(({ note }, index) => {
    if (!Number.isInteger(note.leafIndex) || note.leafIndex < 0) {
      fail(`note ${note.commitment} has no usable leaf index`);
    }
    if (index > 0 && note.leafIndex <= selected[index - 1].note.leafIndex) {
      fail("spend inputs must have strictly ascending leaf indices");
    }
  });
}
